<template>
  <div class="output-params">
    <div class="item-info" style="text-align: center">
      <span style="flex: 2">参数类型</span>
      <span style="flex: 2">参数名</span>
      <span style="flex: 1">是否为数组</span>
      <div style="width: 50px"></div>
    </div>
    <el-tree :data="params" node-key="paramId" default-expand-all :expand-on-click-node="false">
      <span class="item-info" slot-scope="{ node, data }">
        <el-select class="type" filterable v-model="data._type">
          <el-option
            v-for="item in controls"
            :key="item._type"
            :label="item.name"
            :value="item._type"
          ></el-option>
        </el-select>
        <div class="input">
          <span
            v-if="node.level !== 1"
            style="color:red; z-index:10; position: absolute; margin-left: 8px;"
          >
            *
          </span>
          <el-input
            v-model="data.name"
            :placeholder="node.level === 1 && data._type === 'ref' ? '' : '请输入参数名'"
            :disabled="node.level === 1 && data._type === 'ref'"
          ></el-input>
        </div>
        <el-select
          class="is-array"
          v-model="data.array"
          :disabled="from === 'subProcess' && node.level === 1"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <span style="width: 50px; font-size: 18px;">
          <span v-if="node.level !== 1" @click="() => remove(node, data)" style="margin: 0 6px">
            <svg-icon icon-class="workflow_script_del-script1"></svg-icon>
          </span>
          <span v-else style="margin: 0 6px; cursor: not-allowed">
            <svg-icon icon-class="workflow_script_del-script"></svg-icon>
          </span>
          <span v-if="data._type === 'ref'" @click="() => append(data)">
            <svg-icon icon-class="workflow_script_add-script"></svg-icon>
          </span>
          <span v-else style="cursor: not-allowed">
            <svg-icon icon-class="workflow_script_add-script-01"></svg-icon>
          </span>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { bfs, getTreeDeep } from "@/utils/algorithm"

let paramId = 1000
import { getGroupControls } from "@/api/sheet/sheet"
import { randomString } from "@/utils/common"

export default {
  name: "OutputParams",
  props: {
    outputParams: Object,
    from: {
      type: String,
      default: "output"
    }
  },
  data() {
    return {
      controls: [],
      params: []
    }
  },
  created() {
    this.initControls()
    this.initParams()
  },
  computed: {
    typeDataTypeMap() {
      let result = {}
      this.controls.forEach(control => {
        result[control._type] = control._dataType
      })
      return result
    }
  },
  methods: {
    initControls() {
      getGroupControls().then(res => {
        let result = []
        res.forEach(group => {
          result = result.concat(group.options)
        })
        this.controls = result
        // 允许选择所有控件类型
        // this.controls = result.filter(control =>
        //   ["text", "number", "time", "ref"].includes(control._type)
        // )
      })
    },
    initParams() {
      if (this.outputParams) {
        let params = this._.cloneDeep([this.outputParams])
        bfs({
          arr: params,
          childFuc: group => group.controls,
          cbk: group => {
            group.paramId = randomString(10)
            // eslint-disable-next-line no-prototype-builtins
            if (group.hasOwnProperty("controls")) {
              group.children = group.controls
            }
          },
          cloneDeep: false,
          withParent: false
        })
        this.params = params
      } else {
        this.params = [
          {
            paramId: randomString(10),
            _type: "ref",
            array: this.from === "subProcess" ? true : false,
            name: ""
          }
        ]
      }
    },
    append(data) {
      const newChild = { paramId: paramId++, _type: "ref", array: false, children: [], name: "" }
      if (!data.children) {
        this.$set(data, "children", [])
      }
      data.children.push(newChild)
      data.controls = data.children
    },
    remove(node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.paramId === data.paramId)
      children.splice(index, 1)
      data.controls = data.children
    },
    validate() {
      let result = true
      bfs({
        arr: this.params,
        childFuc: group => group.controls,
        cbk: group => {
          // 参数名称不能为空
          if (group._deep > 0 && !group.name) {
            this.$notify.warning({
              title: "提示",
              message: "参数名称不为空"
            })
            result = false
            return false
          }
          // 同级参数名称不能重复
          let names = group.controls?.map(control => control.name) || []
          if (names.length !== this._.uniq(names).length) {
            this.$notify.warning({
              title: "提示",
              message: "同级参数名称不能重复"
            })
            result = false
            return false
          }
        },
        withParent: false
      })
      return result
    },
    getValue() {
      let output = this._.cloneDeep(this.params)
      bfs({
        arr: output,
        childFuc: group => group.controls,
        cbk: group => {
          if (group._type === "ref") {
            group.deep = group.refSheetId ? group.deep : getTreeDeep(group)
            group.oneFlag = !group.array
          }
          group._cid = group.name
          group._dataType = this.typeDataTypeMap[group._type]
        },
        cloneDeep: false,
        withParent: false
      })
      return output[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.output-params {
  .item-info {
    margin-bottom: 5px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    .type {
      width: 120px;
      flex: 0 0 auto;
    }
    .is-array {
      width: 60px;
      flex: 0 0 auto;
    }
    .del-param {
      margin-left: 5px;
      font-size: 20px;
    }
    .add-param {
      margin-left: 5px;
      font-size: 20px;
    }
  }
  .el-select {
    flex: 1;
  }
  .input {
    flex: 2;
    margin: 0 10px;
    display: flex;
    align-items: center;
  }
  ::v-deep {
    .el-input {
      // 因为工作流节点设置覆盖了所有子级,所以临时使用此方式
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      .el-input__suffix,
      .el-input__prefix {
        line-height: 32px;
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
    .el-tree-node__content {
      height: unset;
      &:hover {
        background-color: #fff;
      }
    }
    .el-tree-node__content > .el-tree-node__expand-icon {
      padding-right: 6px;
      padding-left: 0;
    }
  }
}
</style>
